@import '../../../../../../../constants/spacing.module.less';
@import '../../../../../../../constants/screen-width-breakpoints.module.less';
@import '../../new-lineup-plan-grid-shared-styles.module.less';

.shipment-limit-container {
  display: grid;
  grid-template-rows: subgrid;
  grid-template-columns: subgrid;
  grid-row: @shipment-limit-label-grid-area / @shipment-limit-grid-area;
  gap: @space-0;
}

.shipment-dropdown-label {
  grid-area: @shipment-limit-label-grid-area;
  color: var(--gray-212c36);
}

.shipment-dropdown {
  grid-area: @shipment-limit-grid-area;
  width: 100%;
}

.shipment-dropdown-toggler {
  height: 32px;

  @media @tablet, @mobile, @ultramobile {
    height: auto;
    min-height: 32px;
  }
}

.shipment-dropdown-toggler-has-discount {
  height: auto;
  min-height: 32px;
}

.promo-border {
  border: 2px solid var(--purple-8D30F7) !important;
}

.coupon-border {
  border: 2px solid var(--blue-1D5AD8) !important;
}

.shipment-limit-dropdown-toggler-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: @space-8;
}

.shipment-limit-dropdown-menu-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: @space-8;

  padding: 5px @space-8;
}

.read-only-shipments {
  grid-area: @shipment-limit-grid-area;
  display: flex;
  align-items: center;
}
